import { useState } from 'react';
import { Gift, Menu, X } from 'lucide-react';
import { useLocation } from '../contexts/LocationContext';

export default function Header() {
  const { country, countryFlag, setCountry } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleCountry = () => {
    setCountry(country === 'us' ? 'india' : 'us');
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0" onClick={closeMenu}>
            <div className="w-10 h-10 bg-brand-primary rounded-lg flex items-center justify-center">
              <Gift className="w-6 h-6 text-white" />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg sm:text-xl font-bold text-gray-900">SwapGifts</h1>
              <p className="text-xs text-gray-500">Trusted gift exchange platform</p>
            </div>
          </a>

          <nav className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <a href="/how-it-works" className="text-sm font-medium text-gray-700 hover:text-brand-primary transition-colors">
              How It Works
            </a>
            <a href="/about" className="text-sm font-medium text-gray-700 hover:text-brand-primary transition-colors">
              About
            </a>
            <div className="relative group">
              <button className="text-sm font-medium text-gray-700 hover:text-brand-primary transition-colors flex items-center gap-1">
                Tools
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className="absolute left-0 mt-2 w-52 bg-white rounded-lg shadow-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <a href="/gift-ideas" className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-brand-primary rounded-t-lg transition-colors">
                  Gift Ideas Generator
                </a>
                <a href="/budget-calculator" className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-brand-primary rounded-b-lg transition-colors">
                  Budget Calculator
                </a>
              </div>
            </div>
            <a href="/blog" className="text-sm font-medium text-gray-700 hover:text-brand-primary transition-colors">
              Blog
            </a>
            <a href="/faq" className="text-sm font-medium text-gray-700 hover:text-brand-primary transition-colors">
              FAQ
            </a>
            <button
              onClick={toggleCountry}
              className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              title="Switch region"
            >
              <span className="text-lg">{countryFlag}</span>
              <span className="text-xs font-medium text-gray-700">{country === 'us' ? 'US' : 'IN'}</span>
            </button>
            <a
              href="/create"
              className="px-5 py-2.5 bg-brand-primary text-white rounded-lg hover:bg-brand-dark transition-colors font-semibold text-sm shadow-sm"
            >
              Create Exchange
            </a>
          </nav>

          <div className="md:hidden flex items-center gap-3">
            <button
              onClick={toggleCountry}
              className="flex items-center gap-1.5 px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              title="Switch region"
            >
              <span className="text-base">{countryFlag}</span>
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-gray-700" />
              ) : (
                <Menu className="w-6 h-6 text-gray-700" />
              )}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden border-t border-gray-200 py-4 px-0">
            <div className="flex flex-col space-y-1">
              <a
                href="/how-it-works"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                How It Works
              </a>
              <a
                href="/about"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                About
              </a>
              <a
                href="/gift-ideas"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                Gift Ideas Generator
              </a>
              <a
                href="/budget-calculator"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                Budget Calculator
              </a>
              <a
                href="/blog"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                Blog
              </a>
              <a
                href="/faq"
                className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary transition-colors rounded-lg"
                onClick={closeMenu}
              >
                FAQ
              </a>
              <div className="pt-2 border-t border-gray-200">
                <a
                  href="/create"
                  className="block px-4 py-3 text-sm font-semibold text-white bg-brand-primary hover:bg-brand-dark transition-colors rounded-lg text-center"
                  onClick={closeMenu}
                >
                  Create Exchange
                </a>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
